import React from 'react';
import cx from 'classnames';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Select.css';

const SelectWrapper = params =>
  <div
    className={cx(s.root, {
      // TODO: Change to context 'theme'.
      [s[`theme-${params.theme}`]]: params.theme && s[`theme-${params.theme}`],
    })}
  >
    <Select {...params} />
  </div>;

export default withStyles(s)(SelectWrapper);



// WEBPACK FOOTER //
// ./src/shared/components/UI/Select/Select.js